import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "tagging-group" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_4 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_5 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_6 = {
  key: 1,
  class: "row"
}
const _hoisted_7 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_8 = {
  key: 1,
  class: "col-md-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.config && _ctx.config.switch_short_key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taggingItems, (tagEl, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: tagEl.id
            }, [
              (tagEl.short_key == _ctx.config.switch_short_key)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(tagEl.layout), {
                      label: tagEl.label,
                      "short-key": tagEl.short_key,
                      options: tagEl.items,
                      "option-source": tagEl.value_source,
                      "option-source-type": tagEl.value_source_type,
                      modelValue: _ctx.formData[tagEl.short_key],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.formData[tagEl.short_key]) = $event)
                    }, null, 8, ["label", "short-key", "options", "option-source", "option-source-type", "modelValue", "onUpdate:modelValue"]))
                  ]))
                : (index % 2 == 0)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(tagEl.layout), {
                        label: tagEl.label,
                        "short-key": tagEl.short_key,
                        options: tagEl.items,
                        "option-source": tagEl.value_source,
                        "option-source-type": tagEl.value_source_type,
                        modelValue: _ctx.formData[tagEl.short_key],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.formData[tagEl.short_key]) = $event)
                      }, null, 8, ["label", "short-key", "options", "option-source", "option-source-type", "modelValue", "onUpdate:modelValue"]))
                    ], 512)), [
                      [_vShow, _ctx.formData[_ctx.config.switch_short_key] == 1]
                    ])
                  : (index % 2 == 1)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(tagEl.layout), {
                          label: tagEl.label,
                          "short-key": tagEl.short_key,
                          options: tagEl.items,
                          "option-source": tagEl.value_source,
                          "option-source-type": tagEl.value_source_type,
                          modelValue: _ctx.formData[tagEl.short_key],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.formData[tagEl.short_key]) = $event)
                        }, null, 8, ["label", "short-key", "options", "option-source", "option-source-type", "modelValue", "onUpdate:modelValue"]))
                      ], 512)), [
                        [_vShow, _ctx.formData[_ctx.config.switch_short_key] == 1]
                      ])
                    : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taggingItems, (tagEl, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: tagEl.id
            }, [
              (index % 2 == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(tagEl.layout), {
                      label: tagEl.label,
                      "short-key": tagEl.short_key,
                      options: tagEl.items,
                      "option-source": tagEl.value_source,
                      "option-source-type": tagEl.value_source_type,
                      modelValue: _ctx.formData[tagEl.short_key],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.formData[tagEl.short_key]) = $event)
                    }, null, 8, ["label", "short-key", "options", "option-source", "option-source-type", "modelValue", "onUpdate:modelValue"]))
                  ]))
                : _createCommentVNode("", true),
              (index % 2 == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(tagEl.layout), {
                      label: tagEl.label,
                      "short-key": tagEl.short_key,
                      options: tagEl.items,
                      "option-source": tagEl.value_source,
                      "option-source-type": tagEl.value_source_type,
                      modelValue: _ctx.formData[tagEl.short_key],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.formData[tagEl.short_key]) = $event)
                    }, null, 8, ["label", "short-key", "options", "option-source", "option-source-type", "modelValue", "onUpdate:modelValue"]))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
  ])), [
    [_directive_loading, _ctx.showLoading]
  ])
}